import { BaseWebComponentController } from '../../../../../../../../framework/BaseWebComponentController';
import { PatchesGridWebComponent } from '../../patchesGrid';
import { CveGridWebComponent } from '../component/CveGridWebComponent';
import { CveGridView } from '../view/CveGridView';
import { templateCveGrid } from '../view/template';

export class CveGridController extends BaseWebComponentController {
  public component: CveGridWebComponent;
  public view: CveGridView;
  public viewConstructor: typeof CveGridView;

  constructor(component: PatchesGridWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: CveGridView,
      viewTemplate: templateCveGrid,
    });
  }

  injectDependencies(dependencies) {
    super.injectDependencies(dependencies);

    this.view.patchId = this.component.patchId;
  }
}
